export enum NotificationHeaderStyle {
  globalBanner = 'globalBanner',
  localBanner = 'localBanner',
  bubble = 'bubble',
  inline = 'inline',
  toast = 'toast'
}

export enum NotificationMessageType {
  warning = 'warning',
  info = 'info',
  success = 'success',
  content = 'content' // dark option
}

export interface INotificationConfiguration {
  header: string;
  content: string;
  layout?: any;
  type: NotificationMessageType;
  style: NotificationHeaderStyle;
}

export const DefaultNotificationConfiguration: INotificationConfiguration = {
  content: '',
  header: '',
  type: undefined,
  style: undefined
}

